import * as React from 'react';
import { cn } from '../../../ui';
import { formatDate } from '../../../../utils/formatters';

function getTimeAgo(dateStr) {
  const now = Date.now();
  const then = new Date(dateStr).getTime();
  if (isNaN(then)) return '—';

  const diffMs = now - then;
  const mins = Math.floor(diffMs / 60_000);
  const hrs = Math.floor(diffMs / 3600_000);
  const days = Math.floor(diffMs / 86400_000);

  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  if (hrs < 24) return `${hrs}h ago`;
  if (days === 1) return 'Yesterday';
  if (days < 7) return `${days}d ago`;
  return formatDate(dateStr, 'short');
}

function TimeAgo({ date, className }) {
  return (
    <span className={cn('text-body-sm text-text-muted shrink-0 whitespace-nowrap', className)}>
      {getTimeAgo(date)}
    </span>
  );
}

export { TimeAgo, getTimeAgo };
